import { Wired } from 'react-rewired';
import { Message } from 'first-intl';
import { Token, PageableList } from '@hugendubel/ws_client';
import { BonusPoints } from './ui/BonusPoints';
import { WsBonusShopHistoryTransaction } from './ws/result/WsBonusShopHistory';
import { WsAddressList } from './ws/result/WsAddressList';
import { WsBonusShopOrder } from './ws/result/WsBonusShopOrder';
import { EanAvailabilityMap } from './ws/result/WsStockInfo';
import { ReducedProduct } from './ws/result/ReducedProduct';

export type State = Readonly<{
    points: BonusPoints;
    backLink: string | null;
    transactions: WsBonusShopHistoryTransaction[];
    articles: PageableList<ReducedProduct> | null;
    deliveryAddresses: WsAddressList | null;
    lastOrder: WsBonusShopOrder | null;
    eanAvailabilityMap: EanAvailabilityMap | null;
    error: Message | null;
    wsToken: Token | null;
}>;

export const initialState: State = {
    points: new BonusPoints(0),
    backLink: null,
    transactions: [],
    articles: null,
    deliveryAddresses: null,
    lastOrder: null,
    eanAvailabilityMap: null,
    error: null,
    wsToken: null,
};

export const Store = Wired.store<State>(initialState);
